import React from 'react';
import type { RelationshipFilters as FiltersType } from '../../types/relationship';

interface Props {
  filters: FiltersType;
  onChange: (filters: FiltersType) => void;
  onExport: (format: 'JSON' | 'CSV' | 'PNG') => void;
}

const RelationshipFilters: React.FC<Props> = ({ filters, onChange, onExport }) => {
  const handleDepthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange({ ...filters, maxDepth: parseInt(e.target.value) });
  };

  const handleWeakToggle = () => {
    onChange({ ...filters, includeWeak: !filters.includeWeak });
  };

  const handleStrengthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange({ ...filters, minStrength: e.target.value as 'WEAK' | 'MEDIUM' | 'STRONG' });
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      <div className="flex flex-wrap items-center gap-4">
        {/* Depth Filter */}
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">
            Depth:
          </label>
          <select
            value={filters.maxDepth}
            onChange={handleDepthChange}
            className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value={1}>1 degree</option>
            <option value={2}>2 degrees</option>
            <option value={3}>3 degrees</option>
            <option value={4}>4 degrees</option>
            <option value={5}>5 degrees</option>
          </select>
        </div>

        {/* Strength Filter */}
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">
            Min Strength:
          </label>
          <select
            value={filters.minStrength}
            onChange={handleStrengthChange}
            className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="WEAK">Weak</option>
            <option value="MEDIUM">Medium</option>
            <option value="STRONG">Strong</option>
          </select>
        </div>

        {/* Include Weak Toggle */}
        <div className="flex items-center space-x-2">
          <label className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={filters.includeWeak}
              onChange={handleWeakToggle}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="ml-2 text-sm text-gray-700">Include weak relationships</span>
          </label>
        </div>

        {/* Spacer */}
        <div className="flex-1"></div>

        {/* Export Buttons */}
        <div className="flex items-center space-x-2">
          <span className="text-sm font-medium text-gray-700">Export:</span>
          <button
            onClick={() => onExport('JSON')}
            className="px-3 py-1.5 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            JSON
          </button>
          <button
            onClick={() => onExport('CSV')}
            className="px-3 py-1.5 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
          >
            CSV
          </button>
          <button
            onClick={() => onExport('PNG')}
            className="px-3 py-1.5 text-sm bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
            disabled
            title="PNG export coming soon"
          >
            PNG
          </button>
        </div>
      </div>
    </div>
  );
};

export default RelationshipFilters;
